import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [questions, setQuestions] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  // Fetch all support questions/issues from the backend API
  useEffect(() => {
    fetch('https://ucatprepare-198fffc88819.herokuapp.com/api/supportQuestions')
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.name && form.email && form.message) {
      setLoading(true);

      // Post the form data to the backend API
      fetch('https://ucatprepare-198fffc88819.herokuapp.com/api/supportQuestion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      })
        .then((response) => response.json())
        .then((newQuestion) => {
          // Add the new question to the list
          setQuestions([newQuestion, ...questions]);
          setForm({ name: '', email: '', message: '' });
        })
        .catch((error) => console.error('Error submitting data:', error))
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="App">
      <header>
        <h1>UCAT Preparation - Support</h1>
        <p>This is a user support website for the UCAT Preparation iOS mobile app.</p>
        <p>Submit any questions or issues related to the app. Developer Kemin Li will respond as soon as possible.</p>
      </header>

      <section>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <label>Message:</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleInputChange}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </section>

      <section>
        <h2>Submitted Questions/Issues</h2>
        {questions.length > 0 ? (
          <ul>
            {questions.map((q, index) => (
              <li key={index}>
                <p><strong>Name:</strong> {q.name}</p>
                <p><strong>Email:</strong> {q.email}</p>
                <p><strong>Message:</strong> {q.message}</p>
                <p><strong>Date:</strong> {new Date(q.createdAt).toLocaleString()}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p> No questions or issues submitted yet. </p>
        )}
      </section>

      <footer>
        <p>Developer: Kemin Li | Email: <a href="mailto:kemin_li@hotmail.com">kemin_li@hotmail.com</a></p>
        <p>Contact Number: +61490164451</p> 
        <p>Legal Address: 4 Cash Fues Place, Wantirna, VIC, Australia. 3152</p>
      </footer>
    </div>
  );
}

export default App;
